import { LoadablePaint } from '@confluence/loadable';

export const OnboardingTakeoverNewHomeExperienceLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-OnboardingTakeoverNewHomeExperience" */ './OnboardingExperience.tsx'
			)
		).OnboardingTakeoverNewHomeExperience,
});
